import {Component} from "@angular/core";

@Component({
  selector: "extra-validation",
  templateUrl: "./extra-validation.component.html"
})
export class ExtraValidationComponent{

}
